import type { Middleware } from '@tmapy/redux';
import { AppAction, AppState, batch, Dispatch } from '@tmapy/redux';
import { actionSetLayerFeatures } from '@tmapy/mapcore';
import type { GeoJSONFeature } from '@tmapy/mapcore';

import { PREDEFINED_AREAS_SET_FEATURES, UNMANAGED_AREA_LAYERS } from '../areas/constants';
import { NEW_ORDER_CLEAR } from '../orders/constants';

export const mapMiddleware: Middleware<{}, AppState, Dispatch> = (store) => (next) => (action) => {
  return batch(() => {
    const originalAction = next(action);

    switch (action.type) {
      case PREDEFINED_AREAS_SET_FEATURES: {
        store.dispatch(
          actionSetLayerFeatures(
            UNMANAGED_AREA_LAYERS.PREDEFINED_AREAS,
            action.payload as GeoJSONFeature[],
          ),
        );
        return originalAction;
      }
      case NEW_ORDER_CLEAR: {
        store.dispatch(actionSetLayerFeatures(UNMANAGED_AREA_LAYERS.PREDEFINED_AREAS, []));
        return originalAction;
      }
      default: {
        return originalAction;
      }
    }
  });
};
